export default "__VITE_ASSET__EzH1Y8oV__"